import { gql } from '@apollo/client'

export default gql(`
    mutation($ids : [ID!] $project: String) {
        batchArchiveAssets(
            assets: $ids
            project: $project
        )
    }`
)
